module.exports = __webpack_public_path__ + "static/media/WorkExperiencePreparationResumeBuilder.d2babd0f.pdf";